import { render, staticRenderFns } from "./parcelInfoDialog.vue?vue&type=template&id=d2029ff2"
import script from "./parcelInfoDialog.vue?vue&type=script&lang=js"
export * from "./parcelInfoDialog.vue?vue&type=script&lang=js"
import style0 from "./parcelInfoDialog.vue?vue&type=style&index=0&id=d2029ff2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports